import { Badge } from 'antd'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useStore } from 'src/hooks'

type SidebarItemProps = {
   data: any
}

const SidebarItem: React.FC<SidebarItemProps> = observer(({ data }) => {
   const JobsStore = useStore('JobsStore')
   const OrdersStore = useStore('OrdersStore')
   const jobsCount: any = JobsStore.jobsCount
   const [badgeCount, setBadgeCount] = useState<number>(0)

   useEffect(() => {
      if (data?.type === 'draftOrder') {
         OrdersStore.getDraftOrderCount()
      }
   }, [])

   useEffect(() => {
      if (data?.type === 'draftOrder') {
         setBadgeCount(OrdersStore.draftOrderCount)
      } else {
         const count = jobsCount[data?.type] || 0
         setBadgeCount(count)
      }
   }, [Object.values(jobsCount).map((item: any) => item), OrdersStore.draftOrderCount])

   return (
      <Badge count={badgeCount} offset={[24, 7]} overflowCount={99} className={`${badgeCount > 99 ? 'overflow' : ''}`}>
         <span className="nav-item__label">{data?.label}</span>
      </Badge>
   )
})

export default SidebarItem
